import { createSlice } from "@reduxjs/toolkit";
import {
  fetchEmployees, createEmployee,
  getEmployeeById, updateEmployee,
  deleteEmployee, deleteMessageEmployee
} from "./EmployeeMasterActions";

const initialState = {
  employees: [],
  selectedEmployee: null,

  meta: {
    totalRecords: 0,
    totalPages: 0,
    currentPage: 1,
    pageSize: 5,
  },

  loading: false,
  error: null,
};

const employeeSlice = createSlice({
  name: "EmployeeMaster",

  initialState,

  reducers: {},

  extraReducers: (builder) => {
    builder

      .addCase(fetchEmployees.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(fetchEmployees.fulfilled, (state, action) => {
        state.loading = false;

        console.log("SLICE PAYLOAD:", action.payload);

        // Axios response
        const response = action.payload;

        // Your API response:
        // response.data.data.data = employee array
        const responseData = response?.data?.data;

        console.log("RESPONSE DATA:", responseData);
        console.log("EMPLOYEE ARRAY:", responseData?.data);

        // Employee list
        state.employees = responseData?.data || [];

        // Pagination
        state.meta = {
          totalRecords: responseData?.totalRecords || 0,
          totalPages: responseData?.totalPages || 0,
          currentPage: responseData?.currentPage || 1,
          pageSize: responseData?.pageSize || 5,
        };

        console.log("STATE EMPLOYEES:", state.employees);
        console.log("STATE META:", state.meta);
      })

      .addCase(fetchEmployees.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.employees = [];

        state.meta = {
          totalRecords: 0,
          totalPages: 0,
          currentPage: 1,
          pageSize: 5,
        };
      })
      .addCase(createEmployee.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(createEmployee.fulfilled, (state, action) => {
        state.loading = false;

        console.log("CREATE EMPLOYEE RESPONSE:", action.payload);
      })

      .addCase(createEmployee.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(getEmployeeById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(getEmployeeById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedEmployee = action.payload.data;
      })

      .addCase(getEmployeeById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateEmployee.pending, (state) => {
        state.loading = true;
      })

      .addCase(updateEmployee.fulfilled, (state) => {
        state.loading = false;
      })

      .addCase(updateEmployee.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(deleteMessageEmployee.pending, (state) => {
        state.loading = true;
      })

      .addCase(deleteMessageEmployee.fulfilled, (state) => {
        state.loading = false;
      })

      .addCase(deleteMessageEmployee.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(deleteEmployee.pending, (state) => {
        state.loading = true;
      })

      .addCase(deleteEmployee.fulfilled, (state) => {
        state.loading = false;
      })

      .addCase(deleteEmployee.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default employeeSlice.reducer;